module.exports = __webpack_public_path__ + "img/sld_inverter_red_b1_dark.d665d4bc.svg";